import React from 'react';
import { Check, Clock } from 'lucide-react';

const RoadmapPage = () => (
  <div>
    <section className="py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <span className="font-label text-[var(--color-coral)] mb-3 inline-block">ROADMAP</span>
          <h1 className="font-serif text-4xl md:text-5xl mb-4">Where we're going</h1>
          <p className="text-base text-[var(--color-muted)]">Stilos is built for the long game. Here's what's live and what's next.</p>
        </div>

        <div className="space-y-6">
          {[
            { phase: 'Phase 1 — Foundation', status: 'Live', items: [
              { name: 'AI Article Generation (GPT-5.2)', done: true },
              { name: 'Voice-to-Article (Whisper AI)', done: true },
              { name: 'AEO/GEO Optimization', done: true },
              { name: 'Brand Voice Profiles', done: true },
              { name: 'Brand Reporting & Kit', done: true },
              { name: 'Real-time SEO Scoring', done: true },
              { name: 'WordPress Publishing', done: true },
              { name: 'Content Calendar & Scheduling', done: true },
              { name: 'Progressive Web App (PWA)', done: true },
              { name: 'Stripe Payments & Subscriptions', done: true },
              { name: 'Admin Dashboard & Promo Codes', done: true },
            ]},
            { phase: 'Phase 2 — Growth', status: 'Live', items: [
              { name: 'Medium, LinkedIn, Webflow & Ghost Publishing', done: true },
              { name: 'Facebook & Instagram Publishing', done: true },
              { name: 'Bulk Publish (multi-article, one click)', done: true },
              { name: 'AI Content Tools (Repurposer, Headline Analyzer, SEO Tags, Templates)', done: true },
              { name: 'Google Analytics (GA4) Multi-Tenant Integration', done: true },
              { name: 'Content Activity Dashboard', done: true },
              { name: 'GDPR Cookie Consent & Consent Enforcement', done: true },
              { name: 'Database Performance Optimization & Monitoring', done: true },
            ]},
            { phase: 'Q3 2026 — Expansion', status: 'Planned', items: [
              { name: 'Content Calendar View (visual timeline across platforms)', done: false },
              { name: 'Rich Article Editor (review & tweak AI content before publish)', done: false },
              { name: 'Real Social Engagement Metrics (views, likes, shares from platforms)', done: false },
              { name: 'Tauri Desktop App (.exe for Windows, .dmg for macOS)', done: false },
              { name: 'SEO Content Clusters & Pillar Strategy', done: false },
              { name: 'Social Post Generation (short-form for X, LinkedIn, Instagram)', done: false },
              { name: 'Annual Billing & Plan Upgrades', done: false },
            ]},
            { phase: 'Phase 3 — Scale', status: 'Planned', items: [
              { name: 'Team Collaboration & Multi-seat Workspaces', done: false },
              { name: 'White-Label Options', done: false },
              { name: 'Multi-Language Support (EU)', done: false },
              { name: 'Advanced Analytics & AI Citation Tracking', done: false },
              { name: 'Public API Access', done: false },
              { name: 'Emerging Market Expansion', done: false },
            ]},
          ].map((phase, idx) => (
            <div key={idx} className="card p-7">
              <div className="flex items-center justify-between mb-5">
                <div>
                  <h2 className="font-serif text-xl">{phase.phase}</h2>
                </div>
                <span className={`text-[10px] px-3 py-1 rounded-full font-semibold ${
                  phase.status === 'Live' ? 'bg-green-50 text-green-700' :
                  phase.status === 'In Progress' ? 'bg-[rgba(232,115,92,0.08)] text-[var(--color-coral)]' :
                  'bg-[var(--color-surface)] text-[var(--color-muted)]'
                }`}>{phase.status}</span>
              </div>
              <div className="grid md:grid-cols-2 gap-2">
                {phase.items.map((item, iidx) => (
                  <div key={iidx} className="flex items-center gap-2.5 p-2 rounded-lg">
                    {item.done ? (
                      <Check className="w-4 h-4 text-green-600 flex-shrink-0" />
                    ) : (
                      <Clock className="w-4 h-4 text-[var(--color-muted)] flex-shrink-0" />
                    )}
                    <span className={`text-xs ${item.done ? '' : 'text-[var(--color-muted)]'}`}>{item.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default RoadmapPage;
